// extracted by mini-css-extract-plugin
export var creativeTitle = "ProjectInfo-module--creativeTitle--0a744";
export var infoContainer = "ProjectInfo-module--infoContainer--e2583";
export var serviceContainer = "ProjectInfo-module--serviceContainer--4a7f8";